<template>
  <div :class="bem.b()" v-bind="containerAttrs">
    <a-rate v-model:value="value" v-bind="componentAttrs" :style="getStyle">
      <template v-if="$slots.character" #character>
        <slot name="character"> </slot>
      </template>
    </a-rate>
    <slot v-if="$slots.customText || customText" name="customText">
      <ll-html :class="bem.e('extra')" :value="getCustomText" />
    </slot>
  </div>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { omit } from 'lodash-es'
import { computed, useAttrs } from 'vue'
import { rateProps } from './rate'

defineOptions({ name: 'LlRate', inheritAttrs: false })

const props = defineProps(rateProps)
const emits = defineEmits(['update:value'])

const bem = createNamespace('rate')

const attrs = useAttrs()

const value = computed({
  get: () => props.value,
  set: (val) => {
    emits('update:value', val)
  },
})

// 容器样式
const containerAttrs = computed(() => ({
  class: attrs.class as any,
  style: attrs.style as any,
}))

// 组件属性
const componentAttrs = computed(() => {
  return { ...omit(attrs, ['class', 'style']) }
})

const getStyle = computed(() => ({
  fontSize: props.size + 'px',
  color: props.color,
}))

const getCustomText = computed(() => {
  if (typeof props.customText === 'function') {
    return props.customText(value.value)
  }
  return props.customText
})
</script>
